import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { makeValidable } from '@ami/react/core';
import { ThumbConfiguration } from '../../../machines/machine';
import { ReviewQuoteThumbMountData } from './ReviewQuoteThumbMountData';
import { BoltOnMountType } from '../../../machines/machineBoltOnMountTypes';
import { BoltPatternType } from '../../../machines/machineBoltPatternTypes';
import { QuoteMachineThumbMountType } from '../../../quotes/quoteMachineThumbMountTypes';
import { AttachmentPointBase } from '../../../quotes/otherQuoteEntities';
import { OemThumbMountType } from '../../../machines/oemThumbMountType';

const ValidableModalContent = makeValidable(ReviewQuoteThumbMountData);

export class ReviewQuoteThumbMountModal extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();

    this.state = {
      machineOemThumbMount: null,
      boltPattern: null,
      boltOnMount: null,
      showValidations: false,
      thumbConfiguration: null,
    };
  }

  static propTypes = {
    quoteAttachmentPoint: PropTypes.instanceOf(AttachmentPointBase).isRequired,
    attachmentPoint: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    loadingNewConfiguration: PropTypes.bool.isRequired,
    thumbConfiguration: PropTypes.instanceOf(ThumbConfiguration),
    boltOnMountTypes: PropTypes.arrayOf(PropTypes.instanceOf(BoltOnMountType)),
    boltPatternTypes: PropTypes.arrayOf(PropTypes.instanceOf(BoltPatternType)),
    quoteMachineThumbMountTypes: PropTypes.arrayOf(
      PropTypes.instanceOf(QuoteMachineThumbMountType)
    ),
    requiresThumbMount: PropTypes.bool.isRequired,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState({
        machineOemThumbMount:
          this.props.quoteAttachmentPoint.machineOemThumbMount,
        boltPattern: this.props.quoteAttachmentPoint.boltPattern,
        boltOnMount: this.props.quoteAttachmentPoint.boltOnMount,
        thumbConfiguration: this.props.thumbConfiguration,
      });
    }
  }

  save = (e) => {
    if (e) e.preventDefault();
    this.setState({ showValidations: true }, async () => {
      if (this.validableRef.current.isValid()) {
        await this.props.onSave(
          this.state.machineOemThumbMount,
          this.state.boltPattern,
          this.state.boltOnMount
        );
      }
    });
  };

  render() {
    const {
      show,
      onHide,
      loadingNewConfiguration,
      boltOnMountTypes,
      boltPatternTypes,
      quoteMachineThumbMountTypes,
      requiresThumbMount,
      thumbConfiguration,
      attachmentPoint,
    } = this.props;
    const { machineOemThumbMount, boltPattern, boltOnMount, showValidations } =
      this.state;
    return (
      <SimpleModal show={show} size="md">
        <ModalHeader
          title={`Thumb Mount Selection (${attachmentPoint.name})`}
        />
        <ModalBody>
          {thumbConfiguration &&
            quoteMachineThumbMountTypes &&
            requiresThumbMount &&
            thumbConfiguration.oemThumbMount ===
              OemThumbMountType.SometimesHasOemThumbMount && (
              <p>
                Please let us know whether there is a thumb mount available.
              </p>
            )}
          <ValidableModalContent
            show={show}
            ref={this.validableRef}
            showValidations={showValidations}
            onStateChanged={(updated) => this.setState(updated)}
            boltOnMountTypes={boltOnMountTypes}
            boltPatternTypes={boltPatternTypes}
            quoteMachineThumbMountTypes={quoteMachineThumbMountTypes}
            thumbConfiguration={thumbConfiguration}
            machineOemThumbMount={machineOemThumbMount}
            boltPattern={boltPattern}
            boltOnMount={boltOnMount}
            requiresThumbMount={requiresThumbMount}
          />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={onHide}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={this.save}
            disabled={loadingNewConfiguration}
          >
            {loadingNewConfiguration ? (
              <span>
                <i className="fa fa-spin fa-spinner" /> Applying
              </span>
            ) : (
              <span>Apply</span>
            )}
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
